import React from "react";
import { InlineStack, Modal, Text, BlockStack } from "@shopify/polaris";
import { amazon_regions } from "../../Onboarding/components/onboardinghelper";
import { getAmazonLink } from "../../Editproduct/utils/utils";
import { useTranslation } from "react-i18next";
import { countryWithDemonym } from "../..";

export const getCifOrderId = (row: any) => {
    return row?.['cif_order_id'] ?? "";
}

export const getSourceShopID = (props: any) => {
    return props.redux?.current?.source?._id
}

export const getUser = (props: any) => {
    let tempUser = props?.redux?.shop.split(".")[0];
    return tempUser;
}

export const getShopifyOrderId = (obj: any): any => {
    let orderId = "";
    obj?.targets?.map((target: any) => {
        if (target?.marketplace == "shopify") {
            orderId = target?.order_id;
        }
    });
    return orderId;
}

export const getShopifyShopUrl = (orderId: string, props: any) => {
    let shopUrl: string = "";
    if (orderId) {
        let user = getUser(props);
        shopUrl = `https://admin.shopify.com/store/${user}/orders/${orderId}`;
    }
    return shopUrl;
}

export const getAmazonOrderUrl = (orderId: string, props: any) => {
    let url: string = '';
    let amazonLink: string = getAmazonLink(props);
    url = `https://sellercentral.${amazonLink}/orders-v3/order/${orderId}`;
    return url;
}

export const formattedDate = (date: any) => {
    const options: any = { year: 'numeric', month: 'long' };
    const timeOptions: any = { hour: '2-digit', minute: '2-digit' };

    const inputDateTime = new Date(date);
    const date_1 = inputDateTime.toLocaleDateString(undefined, options);
    const time = inputDateTime.toLocaleTimeString(undefined, timeOptions);

    const day = inputDateTime.getDate();
    const ordinalDay = getOrdinalSuffix(day);

    return `${ordinalDay} ${date_1} ${time}`;
}

const getOrdinalSuffix = (day: any) => {
    if (day >= 11 && day <= 13) {
        return `${day}th`;
    }
    switch (day % 10) {
        case 1:
            return `${day}st`;
        case 2:
            return `${day}nd`;
        case 3:
            return `${day}rd`;
        default:
            return `${day}th`;
    }
}

export const getTotalPrice = (row: any) => {
    return `${amazon_regions.find(a => a?.currency === (row?.marketplace_currency ?? ''))?.['currency_symbol'] || ''} ${row?.total?.marketplace_price ?? 0}`
}

export const customModal = (open: boolean, onClose: () => void, title: string, primaryAction: any, structure: any, large: boolean, secondaryActions?: any) => {


    return (
        /* polaris-migrator: Unable to migrate the following expression. Please upgrade manually. */
        <Modal
            size={large ? 'large' : undefined}
            open={open}
            onClose={onClose}
            title={title}
            primaryAction={primaryAction}
            secondaryActions={secondaryActions}
        >
            {
                structure && structure != "" &&
                <Modal.Section>
                    {structure}
                </Modal.Section>
            }
        </Modal>
    );
}

export const necessaryDetails = (props: any) => {
    return {
        'source': {
            'shopId': props.redux?.current?.source?._id, // shopify shop id
            'marketplace': props.redux?.current?.source?.marketplace // shopify
        },
        'target': {
            'shopId': props.redux?.current?.target?._id, // amazon shop id
            'marketplace': props.redux?.current?.target?.marketplace // amazon
        },
    }
}

const getTagAbbreviation = (tag: string) => {
    switch (tag) {
        case "ISPU":
            return "Local Selling"
        default:
            return tag;
    }
}

export const getTags = (row: any) => {
    let obj: any = {
        primaryTag: "",
        remainingCount: 0,
        remaingingTags: []
    }
    let tempArr: any = [];

    if (row?.filter_tags) {
        let tag: string = "";
        row?.filter_tags?.forEach((val: string) => {
            tempArr?.push(getTagAbbreviation(val))
        })
    }
    if (tempArr?.length !== 0) {

        obj = {
            primaryTag: tempArr[0],
            remainingCount: tempArr?.length - 1,
            remaingingTags: tempArr?.slice(1)
        }
    }

    return obj;
}

export const getActionsForOrders = (row: any, props: any) => {
    const country = countryWithDemonym[props?.redux?.current?.target?.warehouses?.[0]?.marketplace_id].country
    let actionObj: any = {
        primaryAction: '',
        syncStatusName: '',
        remainingCount: 0,
        remainingAction: [],
    }

    let tempPrimary: any = '';
    let tempSyncStatusName: any = '';
    let tempArr: any = [];

    if (row?.marketplace_status === "Unshipped") {
        if (row?.targets) {
            row?.targets?.forEach((target: any) => {
                if (target?.shop_id && target?.shop_id === getSourceShopID(props)) {
                    if (target?.status === 'failed' || target?.status === "Disabled") {
                        if (['FR', 'IN', 'IT', 'ES', 'GB', 'US'].includes(country)) {
                            tempArr = ["Archive", "Buy Shipping", "View Order"]
                        }
                        else {
                            tempArr = ["Archive", "View Order"]
                        }
                        tempPrimary = "Resolve";
                        tempSyncStatusName = "Order"
                    }
                    else if (target?.status === "Created") {
                        if (['FR', 'IN', 'IT', 'ES', 'GB', 'US'].includes(country)) {
                            tempPrimary = "Buy Shipping"
                            tempArr = ["Archive", "View Order"]
                        }
                        else {
                            tempPrimary = "Archive"
                            tempArr = ["View Order"]
                        }
                        tempSyncStatusName = ""
                    }
                    else if (target?.status === "Shipped" && row?.shipment_error) {
                        tempPrimary = "Resolve"
                        tempArr = ["Archive", "View Order"]
                        tempSyncStatusName = "Shipment"
                    }
                    if (row?.refund_status && row?.refund_status?.includes('Failed')) {
                        tempPrimary = "Resolve";
                        tempArr = ['Archive', "View Order"]
                        tempSyncStatusName = "Refund"
                    }
                }
            })
        }
    }
    else if (row?.marketplace_status === "Shipped") {
        if (row?.targets) {
            row?.targets?.forEach((target: any) => {
                if (target?.shop_id && target?.shop_id === getSourceShopID(props)) {
                    if (target?.status === 'failed') {
                        tempPrimary = "Resolve";
                        tempArr = ["Archive", "View Order"]
                        tempSyncStatusName = 'Order'
                    }
                    else if (target?.status === "Shipped") {
                        tempPrimary = "Archive"
                        tempArr = ["View Order"]
                        tempSyncStatusName = ''
                    }
                    else if (target?.hasOwnProperty('refund_status')) {
                        if (target?.['refund_status']?.includes('Failed')) {
                            tempPrimary = "Resolve";
                            tempArr = ['Archive', "View Order"]
                            tempSyncStatusName = 'Refund'
                        }
                    }
                }
            })
        }
    }
    else if (row?.marketplace_status === "Partially Shipped") {
        if (row?.targets) {
            row?.targets?.forEach((target: any) => {
                if (target?.shop_id && target?.shop_id === getSourceShopID(props)) {
                    if (target?.status === 'Partially Shipped') {
                        tempPrimary = "Archive";
                        tempArr = ["View Order"]
                        tempSyncStatusName = ''
                    }
                    else if (target?.status === "Shipped") {
                        tempPrimary = "Resolve"
                        tempArr = ["Archive", "View Order"]
                        tempSyncStatusName = 'Shipment'
                    }
                }
            })
        }
    }
    else if (row?.marketplace_status === 'Canceled') {
        if (row?.targets) {
            row?.targets?.forEach((target: any) => {
                if (target?.shop_id && target?.shop_id === getSourceShopID(props)) {
                    if (target?.status === 'failed') {
                        tempPrimary = "Archive";
                        tempArr = ["View Order"]
                        tempSyncStatusName = ''
                    }
                    else if (target?.status === "Created") {
                        tempPrimary = "Resolve"
                        tempArr = ["Archive", "View Order"]
                        tempSyncStatusName = 'Cancellation'
                    }
                    else if (target?.status === "Cancelled") {
                        tempPrimary = "Archive"
                        tempArr = ["View Order"]
                        tempSyncStatusName = ''
                    }
                    else if (target?.hasOwnProperty('refund_status')) {
                        if (target?.['refund_status']?.includes('Failed')) {
                            tempPrimary = "Resolve";
                            tempArr = ['Archive', "View Order"]
                            tempSyncStatusName = 'Refund'
                        }
                    }
                }
            })
        }
    }

    actionObj = {
        primaryAction: tempPrimary,
        syncStatusName: tempSyncStatusName,
        remainingCount: tempArr?.length,
        remainingAction: [...tempArr],
    }

    return actionObj;
}

export const getStatus = (row: any, props: any) => {
    const { t } = useTranslation();
    let statusObj = { amazonStatus: "", shopifyStatus: "" }
    let tempShopify: string = "";

    if (row?.targets) {
        row?.targets?.forEach((target: any) => {
            if (target?.shop_id && target?.shop_id === getSourceShopID(props)) {
                if (target?.status === 'failed')
                    tempShopify = "-";
                else if (target?.status === "Created" && row?.fulfilled_by == "other")
                    tempShopify = "Fulfilled"
                else if (target?.status === "Created")
                    tempShopify = t("Unfulfilled");
                else if (target?.status === "Shipped")
                    tempShopify = t("Fulfilled");
                else if (target?.status === "Partially Shipped")
                    tempShopify = t("Partially Fulfilled");
                else if (target?.cancellation_status && (target?.cancellation_status === "Cancelled" || target?.cancellation_status === "Canceled"))
                    tempShopify = t("Cancelled");
                else tempShopify = t(target?.status);
            }
        })
    }
    else tempShopify = '-'

    statusObj = {
        amazonStatus: t(row?.marketplace_status == 'Canceled' ? "Cancelled" : row?.marketplace_status) ?? "N/A",
        shopifyStatus: tempShopify
    }

    return statusObj;
}

export const getAmazonStatusBadgeProgress = (status: string) => {
    switch (status) {
        case 'Unshipped':
            return 'incomplete'
        case 'Shipped':
            return 'complete'
        default:
            'partiallyComplete'
    }
}

export const getAmazonStatusBadgeColor = (status: string) => {
    switch (status) {
        case 'Unshipped':
            return 'attention';
        case 'Shipped':
            return 'success';
        case 'Partially Shipped':
            return 'success';
        case 'Cancelled':
            return 'warning'
        default:
            return 'new'
    }
}

export const getShopifyStatusBadgeProgress = (status: string, row: any) => {
    switch (status) {
        case "Created":
            if (row?.fulfilled_by == "other") {
                return 'complete';
            }
            else {
                return 'incomplete';
            }
        case 'Shipped':
            return 'complete';
        default:
            return 'partiallyComplete'
    }
}

export const getShopifyBadgeColor = (status: string, row: any) => {
    switch (status) {
        case 'Created':
            if (row?.fulfilled_by == "other") {
                return 'success';
            } else {
                return 'attention';
            }
        case 'Shipped':
            return 'success';
        case 'Partially Shipped':
            return 'success';
        case 'Cancelled':
            return 'warning';
        default:
            return 'new'
    }
}

export const getSyncStatus = (row: any, props: any) => {
    let obj: any = {
        primaryStatus: '',
        remainingCount: 0,
        remaingingStatus: []
    }
    let tempArr: any = [];

    if (row?.targets) {
        row?.targets?.forEach((target: any) => {
            if (target.shop_id == getSourceShopID(props)) {
                if (target.status && (target.status === 'failed' || target?.status === 'Disabled') && (row?.marketplace_status !== "Canceled")) {
                    tempArr?.push('Order')
                }
                if (target.status && target.status === 'Created' && !target?.cancellation_status && !target?.refund_status) {
                    tempArr?.push('Created')
                }
                if (
                    (
                        (
                            (target?.status && target?.status === "Cancelled") ||

                            target?.cancellation_status && target?.cancellation_status == "Cancelled"
                        )
                    )
                    &&
                    (row?.marketplace_status && ((row?.marketplace_status === "Canceled") || (row?.marketplace_status === "Cancelled")))
                ) {
                    tempArr?.push('Cancelled')
                }
                // if (target?.status && target?.status === "Cancelled" && row?.marketplace_status && (row?.marketplace_status === "Canceled" || row?.marketplace_status === "Cancelled")) {
                //     tempArr?.push('Cancelled2')
                // }
                if (target?.status && target?.status === "Shipped" && row?.marketplace_status && (row?.marketplace_status?.includes("Shipped"))) {
                    tempArr?.push('Shipped')
                }
                if (target?.cancellation_status && (target?.cancellation_status === "Failed" || target?.cancellation_status === 'Disabled')) {
                    tempArr?.push('Cancellation')
                }
            }
        })
    }

    if (row?.shipment_error) {
        tempArr?.push('Shipment');
    }

    if (row?.refund_status && row?.refund_status?.includes('Failed')) {
        tempArr?.unshift('Refund');
    }

    if (row?.refund_status && row?.refund_status?.includes('Refund') && !row?.refund_status?.includes('Failed')) {
        tempArr?.push('Refunded');
    }
    if (row?.refund_status && row?.refund_status.includes('Inprogress')) {
        tempArr?.unshift('Refund_in_progress');
    }

    obj = {
        primaryStatus: tempArr[0],
        remainingCount: tempArr?.length - 1,
        remaingingStatus: tempArr?.slice(1)
    }

    return obj;
}

export const getErrorBanner = (row: any, props: any) => {
    let obj: any = {};

    if (row?.targets) {
        row?.targets?.forEach((target: any) => {
            if (target.shop_id == getSourceShopID(props)) {
                if (target.status && (target.status === 'failed' || target?.status === 'Disabled')) {
                    obj['Failed Order'] = target?.errors || "N/A"
                }

                // if (target.status && target.status === 'Created' && (!target?.cancellation_status || !target?.refund_status)) {
                //     obj['Created'] = "Your order has been successfully created!"
                // }
                // if (target?.status && target?.status === "Cancelled" && row?.marketplace_status && (row?.marketplace_status === "Canceled" || row?.marketplace_status === "Cancelled")) {
                //     obj['Cancelled'] = "Your order has been been successfully cancelled!"
                // }

                if (target?.cancellation_status && (target?.cancellation_status === "Failed" || target?.cancellation_status === 'Disabled')) {
                    obj['Failed Cancellation'] = "Reason"  // Need to discuss with mansi
                }
            }
        })
    }
    if (row?.shipment_error) {
        obj['Failed Shipment'] = Array.isArray(row?.shipment_error) && row.shipment_error.length > 0
            ? row.shipment_error[row.shipment_error.length - 1]
            : ""
    }

    if (row?.refund_status && row?.refund_status?.includes('Failed')) {
        obj['Failed Refund'] = row?.refund_failed_reason || "N/A"
    }

    // if (row?.refund_status && row?.refund_status?.includes('Refund')) {
    //     obj['Refunded'] = "Your order has been refunded successfully!"
    // }

    return obj;
}

export const getToolTipContent = (data: any, currency: string, t: any) => {

    return (
        <BlockStack gap="100">
            <InlineStack gap="400"><Text as='p'>{t("Item Price")} : </Text><Text as='p'>{currency} {data?.['marketplace_price'] ?? 0.00}</Text></InlineStack>
            <InlineStack gap="400"><Text as='p'>{t("Item Tax")} : </Text><Text as='p'>{currency} {data?.['tax']?.['marketplace_price'] ?? 0.00}</Text></InlineStack>
            <InlineStack gap="400"><Text as='p'>{t("Item Discount")} : </Text><Text as='p'>{currency} {data?.['discount']?.['marketplace_price'] ?? 0.00}</Text></InlineStack>
        </BlockStack>
    );
}

export const getModalOrderId = (modalData: any) => {
    let order_id = '';
    modalData?.targets?.map((obj: any) => {
        if (obj?.marketplace == "amazon") {
            order_id = obj?.order_id
        }
    });
    return order_id;
}

export const isLeapYear = (year: any) => {
    const daysInLeapYear: number = 366;
    if ((((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0))) return daysInLeapYear;
    else return (daysInLeapYear - 1);
}

export const paramKey = (value: string) => {
    switch (value) {
        case 'failed_order':
            return 'targets.status'
        case 'failed_refund':
            return 'refund_status'
        case 'failed_shipment':
            return 'shipment_error'
        case 'failed_cancellation':
            return 'targets.cancellation_status'
        case 'created':
            return 'targets.status'
        case 'cancelled':
            return 'targets.cancellation_status'
        case 'refunded':
            return 'marketplace_status'
        case 'Refunded':
            return 'refund_status'
    }

}

export const changeSyncStatus = (tag: string, t: any) => {

    switch (tag) {
        case "Order":
            return t("Failed Order")
        case "Shipment":
            return t("Failed Shipment")
        case "Refund":
            return t("Failed Refund")
        case "Created":
            return t("Order Created")
        case "Cancellation":
            return t("Failed Cancellation")
        case "Refund_in_progress":
            return t("Refund Inprogress")
        default:

            return tag
    }
}

export const formatDateForOrderCreation = (months: string[], date_from_api: any, t: any) => {
    const date = new Date(date_from_api);
    const year = date.getFullYear();
    const month = months[date.getMonth()];
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    // Convert hours to AM/PM format
    const ampm = hours >= 12 ? 'pm' : 'am';

    // Adjust hours for 12-hour clock format
    const formattedHours = hours % 12 || 12;

    // Create the formatted date string
    const formattedDate = `${t(month)} ${day}, ${year} at ${formattedHours}:${minutes.toString().padStart(2, '0')} ${ampm}`;

    return formattedDate;
}

export const formattedOrderSummaryDate = (months: string[], date_from_api: any, t: any) => {
    const date = new Date(date_from_api);
    const day = date.getUTCDate();
    const month = months[date.getUTCMonth()];
    const year = date.getUTCFullYear();
    // Get day of the week and format it
    const dayOfWeek = new Intl.DateTimeFormat('en-US', { weekday: 'short' }).format(date);

    // Combine the formatted values
    const formattedDate = `${t(dayOfWeek)}, ${day}${day === 1 ? "st" : (day === 2 ? "nd" : (day === 3 ? "rd" : "th"))} ${month} ${year}`;

    return formattedDate;
}

export const getTotalProductCount = (row: any) => {
    let total: number = 0;
    row?.items?.forEach((item: any) => {
        total += +item?.qty;
    })

    // total *= row?.items?.length;
    return total;
}

export const getCalculatedAmount = (obj: any) => {
    let itemPrice = obj?.price?.marketplace_price ? +obj?.price?.marketplace_price : 0;
    let itemQuantity = obj?.['qty'] ? +obj?.['qty'] : 0;
    let itemTax = obj?.tax?.marketplace_price ? +obj?.tax?.marketplace_price : 0;
    let itemShippingCharge = obj?.shipping_charge?.marketplace_price ? +obj?.shipping_charge?.marketplace_price : 0;
    let itemDiscount = obj?.discount?.marketplace_price ? +obj?.discount?.marketplace_price : 0;
    let calculatedAmount = (itemPrice * itemQuantity) + itemTax + itemShippingCharge - itemDiscount;
    return calculatedAmount;
}